(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mydiaporama"] && !Shopify.designMode) return;
  try {
    
  class MyDiaporamaFade extends HTMLElement {
    connectedCallback() {
      // On attend que le slideshow natif soit prêt
      this._observer = new MutationObserver(() => this._onSlideChange());
      const slideshowComponent = this.querySelector('slideshow-component');
      if (!slideshowComponent) return;

      this._slideshowComponent = slideshowComponent;
      this._observer.observe(slideshowComponent, {
        subtree: true,
        attributeFilter: ['aria-hidden']
      });
    }

    _onSlideChange() {
      const slides = this.querySelectorAll('slideshow-slide');
      const duration = parseInt(
        getComputedStyle(this).getPropertyValue('--mydiaporama-transition-duration') || '600'
      );

      slides.forEach((slide) => {
        const isActive = slide.getAttribute('aria-hidden') === 'false' || !slide.hasAttribute('aria-hidden');
        if (isActive) {
          slide.style.opacity = '1';
          slide.style.visibility = 'visible';
          slide.style.pointerEvents = 'auto';
          slide.style.zIndex = '1';
        } else {
          slide.style.transition = `opacity ${duration}ms ease`;
          slide.style.opacity = '0';
          slide.style.visibility = 'hidden';
          slide.style.pointerEvents = 'none';
          slide.style.zIndex = '0';
        }
      });
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }
  }

  if (!customElements.get('my-diaporama-fade')) {
    customElements.define('my-diaporama-fade', MyDiaporamaFade);
  }

  } catch(e) { console.error(e); }
})();
})();
